if(!customElements.get('hotspot-item')) {
    class HotspotItem extends HTMLElement {
      constructor() {
        super();
        this.capsulesButtons = this.querySelectorAll('button.spot');
        this.shopCapsuleButton = this.querySelector('.shop-capsule');
        this.capsulePopup = this.querySelector('.capsule-popup');
  
        this.capsulesButtons.forEach((item) => {
            const productData = JSON.parse(item.dataset.product);
            item.addEventListener('click', this.openCapsule.bind(this));
          })
  
          document.addEventListener('click', (event) => {
            if(!this.capsulePopup || (!event.target.closest('.capsule-popup') && event.target.id!="loading-overlay" && this.capsulePopup.classList.contains('open'))) {
              this.closeCapsule();
            }
        });
  
        this.shopCapsuleButton.addEventListener('click', this.openCapsule.bind(this));
      }
  
      addToCartAllProducts(){
          var variantIds = [];
          this.closeCapsule();
          this.capsulePopup.querySelectorAll('add-to-cart-form-capsule').forEach((el) => {
            variantIds.push(el.querySelector('[name="id"]').value);
          });
  
          if(variantIds.length <= 0) return false;
  
          $s.post({
            url: '/cart/add.js',
            data: {items:variantIds.map((variantId) =>{ return {id:variantId, quantity:1} })},
            success: ()=>{
              this.qtyChecker = window.document.querySelectorAll(".qty-checker");
              this.qtyChecker.forEach((quantitychecker) => {
                let qtynew = parseInt(quantitychecker.innerHTML);
                  qtynew++;
                  quantitychecker.innerHTML = qtynew;
              });
  
              window.SideCart.updateSideCart(true);
              this.closeCapsule();
            },
            error: function(response){
              $s.addToCartFail(response.description);
            }
          })
        }
  
      openCapsule(e){
        if (!e.target.classList.contains('product-card-tooltip')) {
          $s.showOverlay();
          if (e.target.dataset.product) {
            let productJson = '[' + e.target.dataset.product + ']';
            this.capsulePopup.innerHTML = this.buildCapsulePopUpHtml(productJson);
          } else {
            let productsJson = e.target.dataset.products.substring(0, e.target.dataset.products.length - 1);
            productsJson = '[' + productsJson + ']';
            this.capsulePopup.innerHTML = this.buildCapsulePopUpHtml(productsJson);
          }
  
          this.capsulePopup.querySelector('.close').addEventListener('click', this.closeCapsule.bind(this));
          this.capsulePopup.querySelector('.btn-add-all').addEventListener('click', this.addToCartAllProducts.bind(this));
  
          setTimeout(()=>{
            this.capsulePopup.classList.add('open');
            setTimeout(() => {
              $s.trapFocus(this.capsulePopup, null);
              setTimeout(() => {
                this.createVariantChangeEvents();
              }, 1000);
            }, 50);
          }, 100);
        }
      }
  
        closeCapsule(){
          $s.hideOverlay();
          this.capsulePopup.classList.remove('open');
          $s.removeTrapFocus();
        }
  
        createVariantChangeEvents () {
          var productCards = document.querySelectorAll('.capsule-popup .item.product-main-element.atc')
          var ATCButton = document.querySelector('.capsule-popup .btn.btn-add-all')
          for (var card of productCards) {
            const targetNode = card.querySelector('input[name=id]');
            const config = { attributes: true, childList: false, subtree: false };
  
            const callback = (mutationList, observer) => {
              for (const mutation of mutationList) {
                if (mutation.type === "attributes") {
                  let disabled = false
                  for(var localCard of productCards) {
                    var cardId = localCard.dataset.productId
                    var attr = document.querySelector(`.item-${cardId} button[type=submit]`).getAttribute('disabled')
                    if (attr == 'disabled') disabled = true
                  }
  
                  if (disabled == true) {
                    ATCButton.setAttribute('disabled', 'disabled')
                  } else {
                    ATCButton.removeAttribute('disabled')
                  }
                }
              }
            };
  
            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
          }
        }
  
        buildCapsulePopUpHtml(productJson){
          var capsuleProducts = JSON.parse(productJson);
  
          var availableToPurchase = true;
          [...capsuleProducts].map((item) => {
            var defaultVariant = item.variants.find(x=>x.id==item.default_variant || !item.default_variant);
            if(!defaultVariant.available){
              availableToPurchase = false;
            }
          })
  
          var html = `
          <div class="content flex direction-column">
            <div class="head">
              <h2>${capsuleProducts.length == 1 ? 'Shop the Product' : 'Shop the Look'}</h2>
              <button class="close" aria-label="Close Capsule">
                <svg class="icon icon-close" viewBox="0 0 32 32"><path fill="{{iconColor}}" d="M17.825,16l10.208,10.207l-1.827,1.826L16,17.824L5.793,28.033l-1.826-1.826L14.174,16L3.967,5.793l1.826-1.826L16,14.174 L26.208,3.967l1.825,1.826L17.825,16z"/></svg>
              </button>
            </div>
  
            <div class="wrap">
              <div class="capsule-items">
  
              ${[...capsuleProducts].map((item) => {
                  //var prod = JSON.parse(item.dataset.product);
                  return this.buildCapsulePopupCardHtml(item);
                }).join('')}
              </div>
            </div>
            <div class="foot">
              ${availableToPurchase == true ? '<button type="button" class="btn btn-add-all">ADD ALL PIECES TO BAG</button>' : '<button type="button" disabled="disabled" class="btn btn-add-all">ADD ALL PIECES TO BAG</button>'}
            </div>
          </div>
          `;
  
          return html;
        }
  
        buildCapsulePopupCardHtml(prod){
          var defaultVariant = prod.variants.find(x=>x.id==prod.default_variant || !prod.default_variant);
          var defaultVariantIventory = prod.variants_inventory[defaultVariant.id];
          var productInventoryThreshold = prod.inventory_threshold;
          var inventoryAvailable = defaultVariantIventory.inventory_quantity > productInventoryThreshold;
          
          var html = `
              <product-card-atc data-section="${this.sectionId}-${prod.id}" data-product-id="${prod.id}" class="item item-${prod.id} product-main-element atc" id="main-product-${this.sectionId}">
              <div class="grid">
  
                <div class="grid-item one-half small--two-fifths image-wrapper">
                  <a href="${prod.url}">
                    <img class="img main lazyload" alt="" data-sizes="auto" data-srcset="${this.getImgSrcSet(prod.images[0])}" width="${prod.images[0].width}" height="${prod.images[0].height}" />
                  </a>
                </div>
  
                <div class="grid-item one-half small--three-fifths info-wrapper">
                  <a href="${prod.url}" class="prod-title">${prod.title}</a>
  
  
                  <add-to-cart-form-capsule>
  
                    ${this.buildVariantsInventoryHtml(prod)}
  
                    <div class="price">
                      <span class="final ${( prod.compare_at_price > prod.price ) ? '' : 'regular-final'}">${ $s.formatMoney(prod.price).replace('.00', '')}</span>
                      <span class="compare ${( prod.compare_at_price > prod.price ) ? '' : 'hide'}">${$s.formatMoney(prod.compare_at_price).replace('.00', '')}</span>
                    </div>
                    <div class="atc-options-wrapper">
                      <div class="atc-options hide">Options</div>
                      <form action="/cart/add" method="post" autocomplete="off">
                        <div class="variant-wrapper">
                          ${
                            (prod.current_color) ?
                            `
                              <div class="variant">
                                <span>Color: </span> ${prod.current_color}
                              </div>
                            ` : ''
                          }
                          <product-variants ` + (prod.variants.length==1 ? `class="visually-hidden"` : ``) + `>`;
  
                      if (!prod.has_only_default_variant) {
                        var optionsHtml = '';
                        prod.options.forEach((option,ix)=> {
                          if (option=='Color') {
                            optionsHtml += `<product-swatch class="color-swatches" data-option="${ix + 1}" data-label="${option}"></product-swatch>`;
                          } else {
                            optionsHtml += `<product-dropdown data-option="${ix + 1}" data-label="${option}"></product-dropdown>`;
                          }
                        });
  
                        html += optionsHtml;
                      }
  
  
                      html += `
                            <input data-variant-id="true" type="hidden" name="id" value="${defaultVariant.id}" />
  
                          </product-variants>
                        </div>
  
                        ${
                          (prod.preorder) ?
                            `<div>
                              <div class="red-note">
                                <span>${prod.preorder}</span>
                              </div>
                            </div>` : ''
                        }
  
                        ${
                          (prod.final_sale) ?
                            `<div>
                              <div class="red-note flex justify-content-between align-items-center">
                                <span>${prod.final_sale}</span>
                                <div><svg class="icon" viewBox="0 0 32 32"><path fill="" d="M16.00022.00043A16.01538,16.01538,0,1,0,27.30937,4.69121,15.99974,15.99974,0,0,0,16.00022.00043Zm0,29.53839a13.55389,13.55389,0,1,1,9.5685-3.96975,13.53815,13.53815,0,0,1-9.5685,3.96975ZM18.46175,23.385A1.23091,1.23091,0,0,1,17.231,24.61576H16.00022A1.2306,1.2306,0,0,1,14.76946,23.385V16.0004a1.23077,1.23077,0,1,1,0-2.46153h1.23076A1.23093,1.23093,0,0,1,17.231,14.76963v7.3846A1.23091,1.23091,0,0,1,18.46175,23.385ZM13.84638,9.23119a1.84593,1.84593,0,1,1,.54066,1.30549A1.8457,1.8457,0,0,1,13.84638,9.23119Z"/></svg></div>
                              </div>
                            </div>`
                            : ''
                        }
  
                        <product-buttons>
                          <button type="submit" class="btn add v3" ` + (!defaultVariant.available || !inventoryAvailable ? `disabled="disabled"` : ``) + `>
                            <span class="one-whole btn-text" ` + (!defaultVariant.available || !inventoryAvailable ? `style="display:none;"` : ``) + `>
                              ${(prod.preorder) ? 'PREORDER' : 'ADD'}
                            </span>
                            <span class="sold-out-message" ` + (defaultVariant.available && inventoryAvailable ? `style="display:none;"` : ``) + `>SOLD OUT</span>
                          </button>
                        </product-buttons>
                        <script type="application/json">
                          ${JSON.stringify(prod)}
                        </script>
                      </form>
                    </div>
                  </add-to-cart-form-capsule>
  
                </div>
  
              </div>
              </product-card-atc>
            `;
            return html;
        }
  
        buildVariantsInventoryHtml(prod){
          var html = `
            <div class="variant-inventory">
              ${[...prod.variants].map((variant) => {
                var variantIventory = prod.variants_inventory[variant.id];
                return `
                  <input type="hidden" name="variant_${variant.id}_inventory_available" value="${variantIventory.inventory_quantity > prod.inventory_threshold}" />
                `;
              }).join('')}
            </div>
          `;
  
          return html;
        }
  
        getImgSrcSet(imgData) {
          const sizes = [180,360,540,720,900,1080];
          var ret = [];
          var item;
          for (var i=0; i<sizes.length; i++) {
            if (imgData.width > sizes[i]) {
              item = $s.imgUrlFilter(imgData.src, sizes[i]+'x') + ' ' + sizes[i] + 'w';
              ret.push(item);
            } else {
              item = imgData.src + ' ' + imgData.width + 'w';
              ret.push(item);
              break;
            }
          }
  
          return ret.join(', ');
  
        }
    }
    customElements.define('hotspot-item', HotspotItem);
  }